import { render } from "./packetReceive.vue?vue&type=template&id=496692aa&scoped=true"
import script from "./packetReceive.vue?vue&type=script&lang=js"
export * from "./packetReceive.vue?vue&type=script&lang=js"

import "./packetReceive.vue?vue&type=style&index=0&id=496692aa&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496692aa"]])

export default __exports__